import axios from "axios";

const instance = axios.create({
    baseURL:
        process.env.NODE_ENV === "production"
            ? "https://japi.ctsgroup.nl/ft207"
            : "https://dev-japi.ctsgroup.nl/ft207",
});

export default instance;
